import { Navigate } from "react-router-dom";

import { useAuth } from "hooks/useAuth";

const VendorOnly = ({ component: Component, ...props }) => {
  const { isVendor } = useAuth();

  if (!isVendor) return <Navigate to="/app/crm" replace />;

  return <Component {...props} />;
};

export default VendorOnly;
